export const EXCLUDED_CATEGORIES = ['Project', 'Image', 'TypeCatalog', 'Type'];
